// import lottie from 'lottie-web';

// var animation = lottie.loadAnimation({
//   container: document.getElementById('bm'),
//   renderer: 'svg',
//   loop: true,
//   autoplay: true,
//   path: 'data.json',
// });
import { annotate } from 'rough-notation';
import { isScrolledIntoView, throttle } from './utils';
// Or using unpkg
// import { annotate } from 'https://unpkg.com/rough-notation?module';

window.addEventListener(
  'scroll',
  window.addEventListener(
    'scroll',
    throttle(function (event) {
      const highlightElements = document.querySelectorAll('b:not(.highlighted), strong:not(.highlighted)');
      highlightElements.forEach((element) => {
        if (isScrolledIntoView(element)) {
          element.classList.add('highlighted');
          const annotation = annotate(element, { type: 'highlight', padding: [10, 3, 5, 3], multiline: true });
          setTimeout(() => {
            annotation.show();
          }, 200);
        }
      });
    }, 100)
  ),
  false
);
